export const iconFontAwesomeSecurityVault = (
	<i className="fa-solid fa-vault"></i>
);
